export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-greek-400-normal.woff?a42da273bb968bf2058d98f5797a28f6";